import { Theme } from '@mui/material/styles';
import { ReactNode, useCallback, useMemo, useState } from 'react';

import { DarkTheme } from './DarkTheme';
import { DefaultTheme } from './DefaultTheme';
import { ThemeContext, ThemeType } from './ThemeContext';
import { createTheme } from '@mui/material/styles';

interface ThemeContextProviderProps {
    children: ReactNode;
}

export const ThemeContextProvider = ({ children }: ThemeContextProviderProps) => {
    const [type, setType] = useState<ThemeType>('light');

    const theme = useMemo(() => {
        return createTheme(type === 'dark' ? DarkTheme : DefaultTheme);
    }, [type]);

    const toggleTheme = useCallback(() => {
        setType((prevType) => (prevType === 'light' ? 'dark' : 'light'));
    }, []);

    const val = useMemo(
        () => ({
            theme,
            type,
            toggleTheme,
        }),
        [theme, type, toggleTheme]
    );

    return <ThemeContext.Provider value={val}>{children}</ThemeContext.Provider>;
};

export default ThemeContextProvider;

export const getDefaultThemeType = (): ThemeType => {
    const savedThemeType = localStorage.getItem('theme') as ThemeType;

    if (savedThemeType) {
        return savedThemeType;
    }

    // if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
    //     return 'dark';
    // }

    return 'light';
};
